import Api from '../../api/index';
import idb from "../../idb/custom_fields";
import idb_custom_values from "../../idb_dexie/custom_values.js";
import idb_custom_fields from "../../idb_dexie/custom_fields.js";

const ConfigFlow = {
	namespaced: true,
  state:{
    one_flow: {
      name: '',
      settings: {},
    },

    all_groups: [],
    one_group: {},
    current_group: null,

    all_steps: [],
    one_step: {}
  },
  getters:{
    orderedGroups: (state, getters, rootState) => {
      return state.all_groups.sort((a,b)=> a.position < b.position? -1 : a.position > b.position? 1 : 0)
    },
    orderedStepsFromCurrentGroup: (state, getters, rootState) => {
      if (state.all_steps.length > 0 && state.current_group && state.current_group.id) {
        let group_id = state.current_group && state.current_group.id || null
        let seq = []
        
        if (group_id){
          let arr = state.all_steps.filter(s=> s.group_id == group_id && s.id != null)
          let first = state.all_groups.find(fg => fg.id == group_id)
          if (first){
            first = first.first_step_id
  
            first = arr.find(ar=> ar.id == first)
            seq.push(first)
            
            let current = first
            if (current){
              while (current && current.next.length != 0) {
                let proximos = arr.filter(el => current.next.includes(el.id) )
                seq = [...seq, ...proximos]
                current = proximos[0]
              }
            }
          }
        }
        if (state.all_steps[0].id == null){
          seq.unshift(state.all_steps[0])
        }
  
        return seq
      } else {
        return [];
      }
    },
    orderedStepsByGroup: (state, getters, rootState) => (group_id) =>  {
      group_id = group_id || state.current_group.id
      
      let arr = state.all_steps.filter(s=> s.group_id == group_id)
      let first = state.all_groups.find(fg => fg.id == group_id).first_step_id
      first = arr.find(ar=> ar.id == first)
      let seq = []
      seq.push(first)
      
      let current = first
      while (current.next.length != 0) {
        let proximos = arr.filter(el => current.next.includes(el.id) )
        seq = [...seq, ...proximos]
        current = proximos[0]
      }
      return seq
    },
  },
  mutations:{
    clearGroups(state){
      state.all_groups = []
    },
    clearSteps(state){
      state.all_steps = []
    },
    clearFlow(state){
      state.one_flow = {
        name: '',
        settings: {},
      }
    },
    clearCurrentGroup(state){
      state.current_group = null
    },
    clearOneGroup(state){
      state.one_group = {}
    },
    clearOneStep(state){
      state.one_step = {}
    },
    clearOneStepToEdit(state){
      state.one_step = null
      state.one_step = {}
    },
    clearGroups(state){
      state.all_groups = []
    },
    setCurrentGroup(state, group){
      state.current_group = {...group}
    },
    addGroup(state, {group = {}, next_group_id = null, previous_group_id = null}){
      // LOGICA PARA O BACKEND
      // console.log({group, previous_group_id});
      let is_before = next_group_id || false
      let is_next = previous_group_id || false
      let id = next_group_id || previous_group_id
      let idx = state.all_groups.findIndex((gr) => gr.id == id)
      
      if (is_before) { idx = idx-1}
      if (is_next) { idx = idx+1}
      
      let grs = [...state.all_groups]
      grs.splice(idx, 0, {...group})
      grs = grs.map((gr, idx) => {return {...gr, position: idx}})
      // console.log({grs});
      return state.all_groups = [...grs]
    },
    editOneStep(state, {step_id, step}){
      state.one_step = state.one_step || {}
      if (step_id){
        state.one_step = {...state.one_step, ...state.all_steps.find(s=> s.id == step_id)}
      } else if (step){
        state.one_step = {...state.one_step, ...step}
      }
      state.one_step.next_one = state.one_step.next[0]

    },
    setOneFlow(state, flow) {
      state.one_flow = {...flow};
    },
    setAllGroups(state, groups) {
      state.all_groups = [...groups];
    },
    setAllSteps(state, all_steps) {
      let grouped_steps = all_steps.reduce(function (r, a) {
        r[a.group_id] = r[a.group_id] || [];
        r[a.group_id].push(a);
        return r;
      }, Object.create(null));

      // let grouped_steps = Object.groupBy(all_steps, ({group_id}) => group_id);
      state.all_groups.map((group) => group.id).forEach((group_id) => {
        let idx = state.all_groups.findIndex((group) => group.id == group_id);
        state.all_groups[idx].steps = grouped_steps[group_id] ? [...grouped_steps[group_id]] : [];
      })
      state.all_steps = [...all_steps]
    },
    setGroup(state, group) {
      const group_idx = state.all_groups.findIndex((gr) => gr.id === group.id);
      state.all_groups.splice(group_idx, 1, {...group});
    }
  },
  actions:{
    clearConfig({commit}){
      commit("clearFlow")
      commit("clearGroups")
      commit("clearSteps")
      commit("clearCurrentGroup")
      commit("clearOneGroup")
      commit("clearOneStep")
      commit("clearOneStepToEdit")
    },
    showFlow({commit, dispatch}, flow_id) {
      return Api.Flow.showFlow(flow_id).then(r => r.data).then(async (r) => {
        commit("setOneFlow", r);
        await dispatch('indexGroups', flow_id);
        await dispatch('indexSteps', flow_id);

        return r;
      }).catch(error => {
        console.log(error);
      })
    },
    updateFlow({commit, state, dispatch}, flow) {
      return Api.Flow.updateFlow(flow).then(r=>r.data).then(d=> {
        commit("setOneFlow", d);
        return d
      }).catch(err=> {
        console.log({err});
        throw err
      })
    },

    // END - FLOWS

    // START - GROUPS
    indexGroups({commit}, flow_id) {
      return Api.Flow.indexGroup({}, flow_id).then(r => r.data).then(r => {
        commit("setAllGroups", r);

        return r;
      }).catch(error => {
        console.log(error);
        throw error
      })
    },
    updateGroup({commit, dispatch}, group){
      return Api.Flow.updateGroup(group).then(r=> r.data).then(d => {
        dispatch("indexGroups", group.groupable_id)
        dispatch("setCurrentGroup", d)
        dispatch("indexSteps", group.groupable_id)
        return d
      }).catch(err=> {
        console.log(err);
        throw err
      })
    },
    deleteGroup({commit, dispatch}, group){
      return Api.Flow.deleteGroup(group.id).then(r=> r.data).then(d => {
        dispatch("indexGroups", group.groupable_id)
        dispatch("clearCurrentGroup")
        dispatch("indexSteps", group.groupable_id)
        return d
      }).catch(err=> {
        console.log(err);
        throw err
      })
    },
    reorderGroups({commit, dispatch}, flow){
      return Api.Flow.reorderGroups(flow).then(r=> r.data).then(async d => {
        await dispatch("indexGroups", flow.id)
        await dispatch("clearCurrentGroup")
        await dispatch("indexSteps", flow.id)
        return d
      }).catch(err=> {
        console.log(err);
        throw err
      })
    },
    // END - GROUPS

    // START - STEPS
    indexSteps({commit}, flow_id) {
      return Api.Flow.indexStepByFlow({},flow_id).then(r => r.data).then(r => {
        commit("setAllSteps", r);

        return r;
      }).catch(error => {
        console.log(error);
        throw error
      })
    },
    showStep({commit, dispatch, state}, step_id) {
      step_id = step_id || state.one_step.id
      return Api.Flow.showStep(step_id).then(r => r.data).then(r => {
        commit("editOneStep", {step: r});
      }).catch(error => {
        console.log(error);
        throw err
      })
    },
    createStep({commit, dispatch, state}, step) {
      let {
        id, 
        step_id, 
        title, 
        sentence_image, 
        sentence_image_id, 
        sentence_image_attachment_attributes, 
        sentence, 
        custom_field_id, 
        ...settings
      } = step.item_setup_step_attributes;

      title = step.name;
      sentence = step.name;

      let step_to_create = {
        ...step,
        item_setup_step_attributes: {
          ...step.item_setup_step_attributes,
          status: "active",
          id, 
          step_id, 
          title, 
          sentence_image, 
          sentence_image_attachment_attributes, 
          kind: settings.kind, 
          sentence, 
          custom_field_id,
          settings: {
            ...settings, 
            title, 
            sentence
          }
        }
      };

      let notification = {};
      
      return Api.Flow.createStep(step_to_create).then((r) => r.data).then((step_created) => {
        dispatch('indexGroups', step_created.flow_id).then(() => {
          dispatch('setCurrentGroup', state.all_groups.find(g=> g.id == step_created.group_id))
          dispatch('indexSteps', step_created.flow_id)
        })
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return step_created
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, { root: true });
      });
    },
    updateStep({commit, dispatch, state}, step) {
      if (step.kind == 'item'){
        if (step.item_setup_step_attributes) {

          let {
            id, 
            step_id, 
            title, 
            sentence_image, 
            sentence_image_id, 
            sentence_image_attachment_attributes, 
            sentence, 
            custom_field_id, 
            ...settings
          } = step.item_setup_step_attributes
          title = step.name
          sentence = step.name
          // console.log({sentence_image_attachment_attributes});
          step.item_setup_step_attributes = {
            id, 
            step_id, 
            title, 
            sentence_image, 
            sentence_image_attachment_attributes, 
            kind: settings.kind, 
            sentence, 
            custom_field_id,settings: {
              ...settings, 
              title, 
              sentence
            }
          } 
        } 
      }
      else if (step.kind == 'approval'){
        
      }
      else if  (step.kind == 'divisor'){
        
      }
      else if  (step.kind == 'form'){
      
      }
      if (step.kind != 'item'){
        if (step.item_setup_step_attributes) {
          if (step.item_setup_step_id){
            step.item_setup_step_attributes = {id: step.item_setup_step_id, status: "inactive"}
          } else {
            delete step.item_setup_step_attributes
          }
        }
      }
      if (step.kind != 'approval'){
        if (step.approvals_ids){
          step.approvals_attributes = step.approvals_ids.map(ap=> {return {id: ap, status: "inactive"}})
        }
      }
      if (step.kind != 'form'){
        step.form_id = null
      }
      return Api.Flow.updateStep(step).then(r => r.data).then(async r => {
        await dispatch('indexGroups', r.flow_id).then(async () => {
          await dispatch('indexSteps', r.flow_id)
          dispatch('setCurrentGroup', state.all_groups.find(g=> g.id == r.group_id))
        })
        commit("editOneStep", {step: r});

        return r;
      }).catch(error => {
        console.log({error});
        throw error
      })
    },

    setupEditingStep({commit, dispatch, state}){
      let kind_action_map = {
        item: 'setupItemOnEditingStep',
        form: 'setupFormOnEditingStep',
        approval: 'setupApprovalsOnEditingStep',
        divisor: 'setupDivisorOnEditingStep',
      }
      return dispatch(kind_action_map[state.one_step.kind])
    },
    setupItemOnEditingStep({commit, dispatch, state}){
      let prev = {}
      // state.one_step.item_setup_step_attributes = null
      state.one_step.item_setup_step_attributes = {}
      if (state.one_step.item_setup_step_id){
        let item = {}
        // console.log("entrou")
        return Api.ItemSetupStep.show(state.one_step.item_setup_step_id).then(r=> r.data).then(d=> {
          d = d.data ? d.data.attributes : d 
          d.is_deleted = !!d.deleted_at
          item = d
          let {settings, sentence_image, ...i} = item 
          item = {...i, ...settings}
        }).catch((err) => {
          item = {
            id: state.one_step.item_setup_step_id,
            title: state.one_step.name,
            sentence: state.one_step.name,
            flow_id: state.one_step.flow_id,
            step_id: state.one_step.id,
            kind: null,
            photo: null,
            comment_kind: null,
            needs_verification_by_qr_code: null,
            qr_code_ref: null,
            qr_code_value: null,
            with_error_api: true,
          }
        }).finally(()=>{
          state.one_step.item_setup_step_attributes = {...prev, ...item}
        })
      } else {
        state.one_step.item_setup_step_attributes = {
          ...prev,

          title: state.one_step.name,
          sentence: state.one_step.name,
          flow_id: state.one_step.flow_id,
          step_id: state.one_step.id,
          sentence_image: {},
          sentence_image_attachment_attributes: {},
          kind: null,
          photo: null,
          comment_kind: null,
          needs_verification_by_qr_code: null,
          qr_code_ref: null,
          qr_code_value: null,
        }
      }
      // state.one_step.approvals_attributes = []
    },
    setupFormOnEditingStep({commit, dispatch, state}){

    },
    setupApprovalsOnEditingStep({commit, dispatch, state}){

    },
    setupDivisorOnEditingStep({commit, dispatch, state}){

    },
    // END - STEPS


    clearCurrentGroup({commit}){
      commit('clearCurrentGroup')
    },
    setCurrentGroup({commit}, group){
      commit('setCurrentGroup', group)
    },
    async addGroup({state, commit, dispatch}, {group = {}, next_group_id = null, previous_group_id = null}){
      group.groupable_id = state.one_flow.id 
      group.groupable_type = "Flow"
      

      return Api.Flow.createGroup({...group, previous_group_id, next_group_id}).then(r=> r.data).then(d => {
        dispatch("indexGroups", group.groupable_id)
        dispatch("setCurrentGroup", d)
        return d
      }).catch(err=> {
        console.log(err);
        throw err
      })
    }
  }
}

export default ConfigFlow
